import { ProductApi } from "../products/product.api.js";

export const fetchProducts = async (params = {}) => {
    try {
        const response = await ProductApi.fetchAllProducts(params);
        return response.data.data;
    } catch (error) {
        console.error("Error fetching products:", error);
        throw error;
    }
}

export const fetchProductsByCategorySlug = async (categorySlug) => {
    try {
        const params = { category_slug: categorySlug };
        const response = await ProductApi.fetchProductsByCategory(params);
        return response.data.data;
    } catch (error) {
        console.error("Error fetching products by category:", error);
        throw error;
    }
}

export const fetchProductById = async (productId) => {
    try {
        const response = await ProductApi.fetchProductByIdAPI(productId);
        return response.data.data;
    } catch (error) {
        console.error("Error fetching product by ID:", error);
        throw error;
    }
}
